// extracted by mini-css-extract-plugin
export default {"AdminReport":"AssessmentReport_AdminReport__a8X2u","ReportCard_container":"AssessmentReport_ReportCard_container__-wK9T","reportHeader":"AssessmentReport_reportHeader__IluIL"};